import { render } from "./SettingsSection.vue?vue&type=template&id=1ddc28ac&scoped=true"
import script from "./SettingsSection.vue?vue&type=script&lang=js"
export * from "./SettingsSection.vue?vue&type=script&lang=js"

import "./SettingsSection.vue?vue&type=style&index=0&id=1ddc28ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddc28ac"]])

export default __exports__